// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .tarjeta-formulario {
  background-color: #fff;
} */

/* .tarjeta-formulario * {
  font-family: 'Roboto';
	font-weight: 400;
  font-size: 16px;
} */


.tarjeta-formulario .field {
  position: relative;
  height: 60px;
  min-height: 60px;
  margin-left: 15px;
  margin-right: 15px;
}

.tarjeta-formulario .baseline {
  position: absolute;
  width: 100%;
  height: 1px;
  left: 0;
  bottom: 0;
  background-color: #707070;
  transition: background-color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.tarjeta-formulario label {
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 8px;
  color: #707070;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  transform-origin: 0 50%;
  cursor: text;
  transition-property: color, transform;
  transition-duration: 0.3s;
  transition-timing-function: cubic-bezier(0.165, 0.84, 0.44, 1);
}

.tarjeta-formulario .input {
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 0;
  padding-bottom: 7px;
  color: #383838;
  background-color: transparent;
}

.tarjeta-formulario .input::-webkit-input-placeholder {
  color: transparent;
  -webkit-transition: color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
  transition: color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.tarjeta-formulario .input::-moz-placeholder {
  color: transparent;
  -moz-transition: color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
  transition: color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.tarjeta-formulario .input:-ms-input-placeholder {
  color: transparent;
  -ms-transition: color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
  transition: color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.tarjeta-formulario .input.StripeElement {
  opacity: 0;
  transition: opacity 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
  will-change: opacity;
}

.tarjeta-formulario .input.focused,
.tarjeta-formulario .input:not(.empty) {
  opacity: 1;
}

.tarjeta-formulario .input.focused::-webkit-input-placeholder,
.tarjeta-formulario .input:not(.empty)::-webkit-input-placeholder {
  color: #707070;
}

.tarjeta-formulario .input.focused::-moz-placeholder,
.tarjeta-formulario .input:not(.empty)::-moz-placeholder {
  color: #707070;
}

.tarjeta-formulario .input.focused:-ms-input-placeholder,
.tarjeta-formulario .input:not(.empty):-ms-input-placeholder {
  color: #707070;
}

.tarjeta-formulario .input.focused + label,
.tarjeta-formulario .input:not(.empty) + label {
  color: #888888;
  transform: scale(0.85) translateY(-25px);
  cursor: default;
}

.tarjeta-formulario .input.focused + label {
  color: #888888;
}

.tarjeta-formulario .input.invalid + label {
  color: red;
}

.tarjeta-formulario .input.focused + label + .baseline {
  background-color: #888888;
}

.tarjeta-formulario .input.focused.invalid + label + .baseline {
  background-color: #e25950;
}

.tarjeta-formulario input, .tarjeta-formulario button {
  appearance: none;
  outline: none;
  border-style: none;
}

.tarjeta-formulario input:-webkit-autofill {
  -webkit-text-fill-color: #e39f48;
  -webkit-transition: background-color 100000000s;
  transition: background-color 100000000s;
  animation: 1ms void-animation-out;
  -webkit-animation: 1ms void-animation-out;
}

.tarjeta-formulario .StripeElement--webkit-autofill {
  background: transparent !important;
}

.tarjeta-formulario input, .tarjeta-formulario button {
  animation: 1ms void-animation-out;
  -webkit-animation: 1ms void-animation-out;
}
`, "",{"version":3,"sources":["webpack://./src/app/componentes/pasarela-stripe/stripe.css"],"names":[],"mappings":"AAAA;;GAEG;;AAEH;;;;GAIG;;;AAGH;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,OAAO;EACP,SAAS;EACT,yBAAyB;EACzB,oEAAoE;AACtE;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,qCAAqC;EACrC,yBAAyB;EACzB,8DAA8D;AAChE;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,SAAS;EACT,mBAAmB;EACnB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,iEAAyD;EAAzD,yDAAyD;AAC3D;;AAEA;EACE,kBAAkB;EAClB,8DAAyD;EAAzD,yDAAyD;AAC3D;;AAEA;EACE,kBAAkB;EAClB,6DAAyD;EAAzD,yDAAyD;AAC3D;;AAEA;EACE,UAAU;EACV,2DAA2D;EAC3D,oBAAoB;AACtB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,wCAAwC;EACxC,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EAGE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,+CAAuC;EAAvC,uCAAuC;EACvC,iCAAiC;EACjC,yCAAyC;AAC3C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;EACjC,yCAAyC;AAC3C","sourcesContent":["/* .tarjeta-formulario {\r\n  background-color: #fff;\r\n} */\r\n\r\n/* .tarjeta-formulario * {\r\n  font-family: 'Roboto';\r\n\tfont-weight: 400;\r\n  font-size: 16px;\r\n} */\r\n\r\n\r\n.tarjeta-formulario .field {\r\n  position: relative;\r\n  height: 60px;\r\n  min-height: 60px;\r\n  margin-left: 15px;\r\n  margin-right: 15px;\r\n}\r\n\r\n.tarjeta-formulario .baseline {\r\n  position: absolute;\r\n  width: 100%;\r\n  height: 1px;\r\n  left: 0;\r\n  bottom: 0;\r\n  background-color: #707070;\r\n  transition: background-color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);\r\n}\r\n\r\n.tarjeta-formulario label {\r\n  position: absolute;\r\n  width: 100%;\r\n  left: 0;\r\n  bottom: 8px;\r\n  color: #707070;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  transform-origin: 0 50%;\r\n  cursor: text;\r\n  transition-property: color, transform;\r\n  transition-duration: 0.3s;\r\n  transition-timing-function: cubic-bezier(0.165, 0.84, 0.44, 1);\r\n}\r\n\r\n.tarjeta-formulario .input {\r\n  position: absolute;\r\n  width: 100%;\r\n  left: 0;\r\n  bottom: 0;\r\n  padding-bottom: 7px;\r\n  color: #383838;\r\n  background-color: transparent;\r\n}\r\n\r\n.tarjeta-formulario .input::-webkit-input-placeholder {\r\n  color: transparent;\r\n  transition: color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);\r\n}\r\n\r\n.tarjeta-formulario .input::-moz-placeholder {\r\n  color: transparent;\r\n  transition: color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);\r\n}\r\n\r\n.tarjeta-formulario .input:-ms-input-placeholder {\r\n  color: transparent;\r\n  transition: color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);\r\n}\r\n\r\n.tarjeta-formulario .input.StripeElement {\r\n  opacity: 0;\r\n  transition: opacity 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);\r\n  will-change: opacity;\r\n}\r\n\r\n.tarjeta-formulario .input.focused,\r\n.tarjeta-formulario .input:not(.empty) {\r\n  opacity: 1;\r\n}\r\n\r\n.tarjeta-formulario .input.focused::-webkit-input-placeholder,\r\n.tarjeta-formulario .input:not(.empty)::-webkit-input-placeholder {\r\n  color: #707070;\r\n}\r\n\r\n.tarjeta-formulario .input.focused::-moz-placeholder,\r\n.tarjeta-formulario .input:not(.empty)::-moz-placeholder {\r\n  color: #707070;\r\n}\r\n\r\n.tarjeta-formulario .input.focused:-ms-input-placeholder,\r\n.tarjeta-formulario .input:not(.empty):-ms-input-placeholder {\r\n  color: #707070;\r\n}\r\n\r\n.tarjeta-formulario .input.focused + label,\r\n.tarjeta-formulario .input:not(.empty) + label {\r\n  color: #888888;\r\n  transform: scale(0.85) translateY(-25px);\r\n  cursor: default;\r\n}\r\n\r\n.tarjeta-formulario .input.focused + label {\r\n  color: #888888;\r\n}\r\n\r\n.tarjeta-formulario .input.invalid + label {\r\n  color: red;\r\n}\r\n\r\n.tarjeta-formulario .input.focused + label + .baseline {\r\n  background-color: #888888;\r\n}\r\n\r\n.tarjeta-formulario .input.focused.invalid + label + .baseline {\r\n  background-color: #e25950;\r\n}\r\n\r\n.tarjeta-formulario input, .tarjeta-formulario button {\r\n  -webkit-appearance: none;\r\n  -moz-appearance: none;\r\n  appearance: none;\r\n  outline: none;\r\n  border-style: none;\r\n}\r\n\r\n.tarjeta-formulario input:-webkit-autofill {\r\n  -webkit-text-fill-color: #e39f48;\r\n  transition: background-color 100000000s;\r\n  animation: 1ms void-animation-out;\r\n  -webkit-animation: 1ms void-animation-out;\r\n}\r\n\r\n.tarjeta-formulario .StripeElement--webkit-autofill {\r\n  background: transparent !important;\r\n}\r\n\r\n.tarjeta-formulario input, .tarjeta-formulario button {\r\n  animation: 1ms void-animation-out;\r\n  -webkit-animation: 1ms void-animation-out;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
